import AxiosPipeline from '@/services/api/pipeline/axios_pipeline'

export default {
  createServer: (data) => {
    return AxiosPipeline.post('server', data)
  },

  updateServer: (serverId, data) => {
    return AxiosPipeline.put(`server/${serverId}`, data)
  },

  deleteServer: (serverId) => {
    return AxiosPipeline.delete(`server/${serverId}`)
  },

  getAllServers: (params) => {
    return AxiosPipeline.get('server', { params })
  },

  getServer: (serverId) => {
    return AxiosPipeline.get(`server/${serverId}`)
  },

  getServersByRoutine: (routineId) => {
    return AxiosPipeline.get(`server/routine/${routineId}`)
  },

  getServersByTenant: (tenantId) => {
    return AxiosPipeline.get(`server/tenant/${tenantId}`)
  },
}
